/**
 * A classe da instalação como o servidor calculou, com o motivo e as faixas da norma para conferir.
 * A tela só mostra: nenhuma regra de classificação é repetida aqui (D10).
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { ROTULO_DA_CLASSE, type FlammableInstallationSummary } from '../../../../../types/flammableInstallation';
import { ClassChip } from '../../FlammableChips';
import { capacidadesEmTexto, motivoDaClasse } from '../../flammableTexts';

const FAIXAS_DA_NORMA =
  'Faixas da norma, para conferir o resultado: gases até 1 t ou líquidos até 1 m³ ficam abaixo do limite de classificação (sem classe pela Tabela 1; os demais itens da NR 20 seguem aplicáveis); gases acima de 1 t até 2 t ou líquidos acima de 1 m³ até 10 m³ são a exceção do Anexo II; Classe I vai até 60 t de gás ou 5.000 m³ de líquido; Classe II até 600 t ou 50.000 m³; acima disso, Classe III. Líquido com ponto de fulgor acima de 93 °C não conta, a menos que seja guardado aquecido.';

export const ClasseCalculada: React.FC<{ summary: FlammableInstallationSummary }> = ({ summary }) => {
  const { classification } = summary;
  const semDados = classification.class === 'SEM_DADOS';
  const capacidades = capacidadesEmTexto(summary);

  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
          flexWrap: 'wrap',
          p: 2,
          borderRadius: 1,
          bgcolor: 'action.hover',
        }}
      >
        <ClassChip classe={classification.class} />
        <Box sx={{ flex: 1, minWidth: 240 }}>
          <Typography variant="subtitle1" component="p" fontWeight={700}>
            {semDados
              ? 'Cadastre os produtos para o sistema calcular a classe.'
              : `${ROTULO_DA_CLASSE[classification.class]}, ${motivoDaClasse(classification)}`}
          </Typography>
          {capacidades && <Typography variant="body1">Capacidade somada: {capacidades}.</Typography>}
          {classification.activityBelowCapacity && (
            <Typography variant="body1">
              A capacidade armazenada sugere uma classe maior do que a da atividade. O laudo registra esse aviso.
            </Typography>
          )}
        </Box>
      </Box>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
        {FAIXAS_DA_NORMA}
      </Typography>
    </Box>
  );
};

export default ClasseCalculada;
